<template>
  <div class="vux-toast">
    <div class="weui_mask_transparent" v-show="show"></div>
    <div class="weui_toast" :style="{width: width}" :class="toastClass" v-show="show" :transition="transition">
      <i class="weui_icon_toast" v-show="type !== 'text'"></i>
      <p class="weui_toast_content" v-if="text" v-html="text"></p>
      <p class="weui_toast_content" v-else>
        <slot></slot>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: { // 是否展示
      type: Boolean,
      default: false
    },
    time: { // 持续时间
      type: Number,
      default: 2000
    },
    type: { // 是否成功打开
      type: String,
      default: 'success'
    },
    transition: { // 展示动画
      type: String,
      default: 'vux-fade'
    },
    width: { // toast 的宽度
      type: String,
      default: '100/@w'
    },
    text: String
  },
  data () {
    return {
      show: false
    }
  },
  created () {
    if (this.value) {
      this.show = true
    }
  },
  computed: {
    toastClass () {
      return {
        'weui_toast_forbidden': this.type === 'warn',
        'weui_toast_cancel': this.type === 'cancel',
        'weui_toast_success': this.type === 'success',
        'weui_toast_text': this.type === 'text'
      }
    }
  },
  watch: {
    show (val) {
      if (val) {
        this.$emit('on-show')
        this.$emit('input', true)
      }
      if (val) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.show = false
          this.$emit('input', false)
          this.$emit('on-hide')
        }, this.time)
      }
    },
    value (val) {
      this.show = val
    }
  }
}
</script>
<style lang="less">
@import '../../styles/transition.less';
@import '../../styles/cui/widget/cui_tips/cui_mask';
@import '../../styles/cui/icon/cui_icon_font';
@import '../../styles/cui/widget/cui_tips/cui_toast';
.weui_toast {
  transform: translateX(-50%);
  margin-left: 0!important;
}

.weui_toast_forbidden {
  color: #F76260;
}

.weui_toast.weui_toast_text {
  min-height: 0;
}

.weui_toast_text .weui_toast_content {
  margin: 0;
  padding-top: 10/@w;
  padding-bottom: 10/@w;
  border-radius: 15/@w;
}

.weui_toast_success .weui_icon_toast:before {
  content: "\EA08";
}

.weui_toast_cancel .weui_icon_toast:before {
  content: "\EA0D";
}

.weui_toast_forbidden .weui_icon_toast:before {
  content: "\EA0B";
  color: #F76260;
}
</style>



// WEBPACK FOOTER //
// toast.vue?2c8b7a8a